
<v-select
    v-if="value"
    :items         = "items"
    item-value     = "id"
    item-text      = "name"
    v-model        = "seletced"
    :label         = "seletced.name"
    :return-object = true
    :readonly      = "readonly"
    :hide-details  = "true"
    class          = "country-select"
    @change        = "onChanged"
    style="width: 55px; margin-top: 0"
>
    <template v-slot:item="{ item }">
        <div class="v-flex">
            <div class="mr-2">
                <v-icon size="18" >{{ item.symbol }} </v-icon>
            </div>
            <div>
                {{ item.name }}
            </div>
        </div>
    </template>
    <template v-slot:selection="{ item }">
        <v-icon class="pl-2" size="18" color="primary">{{ item.symbol }} </v-icon>
    </template>
</v-select>
